import { Reducer } from "../../lib/redux";
import { ActiveUserActions } from "./actions";
import { ActiveUserActionTypes } from "./types";

export const defaultActiveUsers: DeepReadonlyArray<string> = [];

export const activeUsers: Reducer<DeepReadonlyArray<string>, ActiveUserActions> = (state = defaultActiveUsers, action) => {
    switch (action.type) {
        case ActiveUserActionTypes.SET_ACTIVE_USERS: {
            return action.payload;
        }
        case ActiveUserActionTypes.CLEAR_ACTIVE_USERS: {
            return [];
        }
        default:
            return state;
    }
};